<template>
  <div class="container main">
    <pulse-loader
      :loading="loading"
      :color="color"
      :size="size"
      class="vue-loader"
    ></pulse-loader>
    <div class="row">
      <div class="col-md-12">
        <SectionTitle
          title="Desempenho por Indicador"
          description="Resultado dos indicadores detalhados por equipe"
          url="/desempenho-por-equipe"
          modalDocumento="Indicador"
        />
      </div>
      <div class="col-md-12">
        <div class="filter-select">
          <vue-select
            :options="equipes"
            label="no_equipe"
            placeholder="Equipes"
            @input="onChangeEquipe"
          >
            <template slot="option" slot-scope="option">
              {{ option.no_equipe }}
            </template>
            <div slot="no-options">Não há opções correspondentes</div>
          </vue-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="accordion" role="tablist" id="accordion-indicadores">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" role="tab">
              <b-button block v-b-toggle.accordion-1 variant="">
                Proporção de gestantes com pelo menos 6 (seis) consultas
                pré-natal realizadas, sendo a primeira até a 12ª semana de
                gestação
                <span class="when-opened">
                  <i class="icofont-rounded-down"></i>
                </span>
                <span class="when-closed">
                  <i class="icofont-rounded-up"></i>
                </span>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-1"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <table class="table table-responsive table-striped">
                  <thead>
                    <tr>
                      <th>Numerador</th>
                      <th>Denominador</th>
                      <!-- <th>
                                                Denominador estimado
                                            </th> -->
                      <th>Resultado</th>
                      <th>Quadrimestre</th>
                      <th>Status</th>
                      <th>Fonte</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-html="
                        printDataPrevisao(
                          indicadores.pn_6_consultas_numerador_preliminar,
                          indicadores.pn_6_consultas_denominador_preliminar,
                          indicadores.pn_6_consultas_resultado_preliminar,
                          'pre-natal'
                        )
                      "
                    ></tr>
                    <!-- <tr
                      v-html="
                        printData(
                          indicadores.pn_6_consultas_numerador,
                          indicadores.pn_6_consultas_denominador,
                          indicadores.pn_6_consultas_denominador_estimado,
                          indicadores.pn_6_consultas_resultado,
                          'pre-natal',
                          indicadores.quadrimestre
                        )
                      "
                    ></tr> -->
                  </tbody>
                </table>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" role="tab">
              <b-button block v-b-toggle.accordion-2>
                Proporção de gestantes com realização de exames para sífilis e
                HIV.
                <span class="when-opened">
                  <i class="icofont-rounded-down"></i>
                </span>
                <span class="when-closed">
                  <i class="icofont-rounded-up"></i>
                </span>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-2"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <table class="table table-responsive table-striped">
                  <thead>
                    <tr>
                      <th>Numerador</th>
                      <th>Denominador</th>
                      <!-- <th>
                                                Denominador estimado
                                            </th> -->
                      <th>Resultado</th>
                      <th>Quadrimestre</th>
                      <th>Status</th>
                      <th>Fonte</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-html="
                        printDataPrevisao(
                          indicadores.pn_hiv_sifilis_numerador_preliminar,
                          indicadores.pn_hiv_sifilis_denominador_preliminar,
                          indicadores.pn_hiv_sifilis_resultado_preliminar,
                          'hiv-sifilis'
                        )
                      "
                    ></tr>
                    <!-- <tr
                      v-html="
                        printData(
                          indicadores.pn_hiv_sifilis_numerador,
                          indicadores.pn_hiv_sifilis_denominador,
                          indicadores.pn_hiv_sifilis_denominador_estimado,
                          indicadores.pn_hiv_sifilis_resultado,
                          'hiv-sifilis',
                          indicadores.quadrimestre
                        )
                      "
                    ></tr> -->
                  </tbody>
                </table>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" role="tab">
              <b-button block v-b-toggle.accordion-3>
                Proporção de gestantes com atendimento odontológico realizado.
                <span class="when-opened">
                  <i class="icofont-rounded-down"></i>
                </span>
                <span class="when-closed">
                  <i class="icofont-rounded-up"></i>
                </span>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-3"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <table class="table table-responsive table-striped">
                  <thead>
                    <tr>
                      <th>Numerador</th>
                      <th>Denominador</th>
                      <!-- <th>
                                                Denominador estimado
                                            </th> -->
                      <th>Resultado</th>
                      <th>Quadrimestre</th>
                      <th>Status</th>
                      <th>Fonte</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-html="
                        printDataPrevisao(
                          indicadores.pn_odontologia_numerador_preliminar,
                          indicadores.pn_odontologia_denominador_preliminar,
                          indicadores.pn_odontologia_resultado_preliminar,
                          'consultas-odontologicas'
                        )
                      "
                    ></tr>
                    <!-- <tr
                      v-html="
                        printData(
                          indicadores.pn_odontologia_numerador,
                          indicadores.pn_odontologia_denominador,
                          indicadores.pn_odontologia_denominador_estimado,
                          indicadores.pn_odontologia_resultado,
                          'consultas-odontologicas',
                          indicadores.quadrimestre
                        )
                      "
                    ></tr> -->
                  </tbody>
                </table>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" role="tab">
              <b-button block v-b-toggle.accordion-4>
                Cobertura de exame citopatológico.
                <span class="when-opened">
                  <i class="icofont-rounded-down"></i>
                </span>
                <span class="when-closed">
                  <i class="icofont-rounded-up"></i>
                </span>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-4"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <table class="table table-responsive table-striped">
                  <thead>
                    <tr>
                      <th>Numerador</th>
                      <th>Denominador</th>
                      <!-- <th>
                                                Denominador estimado
                                            </th> -->
                      <th>Resultado</th>
                      <th>Quadrimestre</th>
                      <th>Status</th>
                      <th>Fonte</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-html="
                        printDataPrevisao(
                          indicadores.citopatologico_numerador_preliminar,
                          indicadores.citopatologico_denominador_preliminar,
                          indicadores.citopatologico_resultado_preliminar,
                          'citopatologico'
                        )
                      "
                    ></tr>
                    <!-- <tr
                      v-html="
                        printData(
                          indicadores.citopatologico_numerador,
                          indicadores.citopatologico_denominador,
                          indicadores.citopatologico_denominador_estimado,
                          indicadores.citopatologico_resultado,
                          'citopatologico',
                          indicadores.quadrimestre
                        )
                      "
                    ></tr> -->
                  </tbody>
                </table>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" role="tab">
              <b-button block v-b-toggle.accordion-5>
                Cobertura vacinal de Poliomielite inativada e da Pentavalente.
                <span class="when-opened">
                  <i class="icofont-rounded-down"></i>
                </span>
                <span class="when-closed">
                  <i class="icofont-rounded-up"></i>
                </span>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-5"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <table class="table table-responsive table-striped">
                  <thead>
                    <tr>
                      <th>Numerador</th>
                      <th>Denominador</th>
                      <!-- <th>
                                                Denominador estimado
                                            </th> -->
                      <th>Resultado</th>
                      <th>Quadrimestre</th>
                      <th>Status</th>
                      <th>Fonte</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-html="
                        printDataPrevisao(
                          indicadores.crianca_polio_penta_numerador_preliminar,
                          indicadores.crianca_polio_penta_denominador_preliminar,
                          indicadores.crianca_polio_penta_resultado_preliminar,
                          'polio-penta'
                        )
                      "
                    ></tr>
                    <!-- <tr
                      v-html="
                        printData(
                          indicadores.crianca_polio_penta_numerador,
                          indicadores.crianca_polio_penta_denominador,
                          indicadores.crianca_polio_penta_denominador_estimado,
                          indicadores.crianca_polio_penta_resultado,
                          'polio-penta',
                          indicadores.quadrimestre
                        )
                      "
                    ></tr> -->
                  </tbody>
                </table>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" role="tab">
              <b-button block v-b-toggle.accordion-6>
                Percentual de pessoas hipertensas com Pressão Arterial aferida
                em cada semestre.
                <span class="when-opened">
                  <i class="icofont-rounded-down"></i>
                </span>
                <span class="when-closed">
                  <i class="icofont-rounded-up"></i>
                </span>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-6"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <table class="table table-responsive table-striped">
                  <thead>
                    <tr>
                      <th>Numerador</th>
                      <th>Denominador</th>
                      <!-- <th>
                                                Denominador estimado
                                            </th> -->
                      <th>Resultado</th>
                      <th>Quadrimestre</th>
                      <th>Status</th>
                      <th>Fonte</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-html="
                        printDataPrevisao(
                          indicadores.pa_hipertensao_numerador_preliminar,
                          indicadores.pa_hipertensao_denominador_preliminar,
                          indicadores.pa_hipertensao_resultado_preliminar,
                          'hipertensao'
                        )
                      "
                    ></tr>
                    <!-- <tr
                      v-html="
                        printData(
                          indicadores.pa_hipertensao_numerador,
                          indicadores.pa_hipertensao_denominador,
                          indicadores.pa_hipertensao_denominador_estimado,
                          indicadores.pa_hipertensao_resultado,
                          'hipertensao',
                          indicadores.quadrimestre
                        )
                      "
                    ></tr> -->
                  </tbody>
                </table>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" role="tab">
              <b-button block v-b-toggle.accordion-7>
                Percentual de diabéticos com solicitação de hemoglobina glicada.
                <span class="when-opened">
                  <i class="icofont-rounded-down"></i>
                </span>
                <span class="when-closed">
                  <i class="icofont-rounded-up"></i>
                </span>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-7"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <table class="table table-responsive table-striped">
                  <thead>
                    <tr>
                      <th>Numerador</th>
                      <th>Denominador</th>
                      <!-- <th>
                                                Denominador estimado
                                            </th> -->
                      <th>Resultado</th>
                      <th>Quadrimestre</th>
                      <th>Status</th>
                      <th>Fonte</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-html="
                        printDataPrevisao(
                          indicadores.hg_diabetes_numerador_preliminar,
                          indicadores.hg_diabetes_denominador_preliminar,
                          indicadores.hg_diabetes_resultado_preliminar,
                          'hemoglobina'
                        )
                      "
                    ></tr>
                    <!-- <tr
                      v-html="
                        printData(
                          indicadores.hg_diabetes_numerador,
                          indicadores.hg_diabetes_denominador,
                          indicadores.hg_diabetes_denominador_estimado,
                          indicadores.hg_diabetes_resultado,
                          'hemoglobina',
                          indicadores.quadrimestre
                        )
                      "
                    ></tr> -->
                  </tbody>
                </table>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import SectionTitle from './SectionTitle'
import utils from '@/mixins/utils.js'

export default {
  name: 'DesempenhoPorEquipePorIndicador',
  components: {
    SectionTitle,
    PulseLoader,
  },
  mixins: [utils],
  data() {
    return {
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      indicadores: {
        citopatologico_numerador: '',
        citopatologico_denominador: '',
        citopatologico_denominador_estimado: '',
        citopatologico_resultado: '',
        citopatologico_numerador_preliminar: '',
        citopatologico_denominador_preliminar: '',
        citopatologico_denominador_estimado_preliminar: '',
        citopatologico_resultado_preliminar: '',
        pn_6_consultas_numerador: '',
        pn_6_consultas_denominador: '',
        pn_6_consultas_denominador_estimado: '',
        pn_6_consultas_resultado: '',
        pn_6_consultas_numerador_preliminar: '',
        pn_6_consultas_denominador_preliminar: '',
        pn_6_consultas_denominador_estimado_preliminar: '',
        pn_6_consultas_resultado_preliminar: '',
        pn_odontologia_numerador: '',
        pn_odontologia_denominador: '',
        pn_odontologia_denominador_estimado: '',
        pn_odontologia_resultado: '',
        pn_odontologia_numerador_preliminar: '',
        pn_odontologia_denominador_preliminar: '',
        pn_odontologia_denominador_estimado_preliminar: '',
        pn_odontologia_resultado_preliminar: '',
        pn_hiv_sifilis_numerador: '',
        pn_hiv_sifilis_denominador: '',
        pn_hiv_sifilis_denominador_estimado: '',
        pn_hiv_sifilis_resultado: '',
        pn_hiv_sifilis_numerador_preliminar: '',
        pn_hiv_sifilis_denominador_preliminar: '',
        pn_hiv_sifilis_denominador_estimado_preliminar: '',
        pn_hiv_sifilis_resultado_preliminar: '',
        hg_diabetes_numerador: '',
        hg_diabetes_denominador: '',
        hg_diabetes_denominador_estimado: '',
        hg_diabetes_resultado: '',
        hg_diabetes_numerador_preliminar: '',
        hg_diabetes_denominador_preliminar: '',
        hg_diabetes_denominador_estimado_preliminar: '',
        hg_diabetes_resultado_preliminar: '',
        pa_hipertensao_numerador: '',
        pa_hipertensao_denominador: '',
        pa_hipertensao_denominador_estimado: '',
        pa_hipertensao_resultado: '',
        pa_hipertensao_numerador_preliminar: '',
        pa_hipertensao_denominador_preliminar: '',
        pa_hipertensao_denominador_estimado_preliminar: '',
        pa_hipertensao_resultado_preliminar: '',
        crianca_polio_penta_numerador: '',
        crianca_polio_penta_denominador: '',
        crianca_polio_penta_denominador_estimado: '',
        crianca_polio_penta_resultado: '',
        crianca_polio_penta_numerador_preliminar: '',
        crianca_polio_penta_denominador_preliminar: '',
        crianca_polio_penta_denominador_estimado_preliminar: '',
        crianca_polio_penta_resultado_preliminar: '',
        quadrimestre: '',
      },
      loading: false,
      size: '40px',
      color: '#0D98BB',
    }
  },
  computed: {
    equipes() {
      return this.removeDuplicate(this.$store.getters['getEquipes'], 'nu_ine')
    },
  },
  created() {
    this.init()
  },
  methods: {
    async onChangeEquipe(event) {
      this.equipe = event.nu_ine
      try {
        this.loading = true
        let response = await this.$api.get(
          '/app/desempenho-por-equipe/' + this.cod_ibge + '/' + this.equipe
        )
        if (response) {
          this.resetIndicadores()
          this.indicadores.citopatologico_numerador =
            response.data[0].citopatologico_numerador
          this.indicadores.citopatologico_denominador =
            response.data[0].citopatologico_denominador
          this.indicadores.citopatologico_denominador_estimado =
            response.data[0].citopatologico_denominador_estimado
          this.indicadores.citopatologico_resultado =
            response.data[0].citopatologico_resultado
          this.indicadores.pn_6_consultas_numerador =
            response.data[0].pn_6_consultas_numerador
          this.indicadores.pn_6_consultas_denominador =
            response.data[0].pn_6_consultas_denominador
          this.indicadores.pn_6_consultas_denominador_estimado =
            response.data[0].pn_6_consultas_denominador_estimado
          this.indicadores.pn_6_consultas_resultado =
            response.data[0].pn_6_consultas_resultado
          this.indicadores.pn_odontologia_numerador =
            response.data[0].pn_odontologia_numerador
          this.indicadores.pn_odontologia_denominador =
            response.data[0].pn_odontologia_denominador
          this.indicadores.pn_odontologia_denominador_estimado =
            response.data[0].pn_odontologia_denominador_estimado
          this.indicadores.pn_odontologia_resultado =
            response.data[0].pn_odontologia_resultado
          this.indicadores.pn_hiv_sifilis_numerador =
            response.data[0].pn_hiv_sifilis_numerador
          this.indicadores.pn_hiv_sifilis_denominador =
            response.data[0].pn_hiv_sifilis_denominador
          this.indicadores.pn_hiv_sifilis_denominador_estimado =
            response.data[0].pn_hiv_sifilis_denominador_estimado
          this.indicadores.pn_hiv_sifilis_resultado =
            response.data[0].pn_hiv_sifilis_resultado
          this.indicadores.hg_diabetes_numerador =
            response.data[0].hg_diabetes_numerador
          this.indicadores.hg_diabetes_denominador =
            response.data[0].hg_diabetes_denominador
          this.indicadores.hg_diabetes_denominador_estimado =
            response.data[0].hg_diabetes_denominador_estimado
          this.indicadores.hg_diabetes_resultado =
            response.data[0].hg_diabetes_resultado
          this.indicadores.pa_hipertensao_numerador =
            response.data[0].pa_hipertensao_numerador
          this.indicadores.pa_hipertensao_denominador =
            response.data[0].pa_hipertensao_denominador
          this.indicadores.pa_hipertensao_denominador_estimado =
            response.data[0].pa_hipertensao_denominador_estimado
          this.indicadores.pa_hipertensao_resultado =
            response.data[0].pa_hipertensao_resultado
          this.indicadores.crianca_polio_penta_numerador =
            response.data[0].crianca_polio_penta_numerador
          this.indicadores.crianca_polio_penta_denominador =
            response.data[0].crianca_polio_penta_denominador
          this.indicadores.crianca_polio_penta_denominador_estimado =
            response.data[0].crianca_polio_penta_denominador_estimado
          this.indicadores.crianca_polio_penta_resultado =
            response.data[0].crianca_polio_penta_resultado
          this.indicadores.quadrimestre = response.data[0].quadrimestre

          // busca os dados
          let response2 = await this.$api.get(
            '/app/indicadores-aps/resultado/todos/' + this.cod_ibge
          )
          const dadosDaEquipe = response2.data.filter((item) => {
            return item.ibge_ine == this.equipe
          })
          const preNatal = dadosDaEquipe.find(
            (item) => Number(item.indicador) == 1
          )
          const hivSifilis = dadosDaEquipe.find(
            (item) => Number(item.indicador) == 2
          )
          const odontologia = dadosDaEquipe.find(
            (item) => Number(item.indicador) == 3
          )
          const citologico = dadosDaEquipe.find(
            (item) => Number(item.indicador) == 4
          )
          const polioPenta = dadosDaEquipe.find(
            (item) => Number(item.indicador) == 5
          )
          const hipertensao = dadosDaEquipe.find(
            (item) => Number(item.indicador) == 6
          )
          const diabetes = dadosDaEquipe.find(
            (item) => Number(item.indicador) == 7
          )

          if (preNatal != undefined) {
            this.indicadores.pn_6_consultas_denominador_preliminar =
              preNatal.denominador
            this.indicadores.pn_6_consultas_numerador_preliminar =
              preNatal.numerador
            this.indicadores.pn_6_consultas_resultado_preliminar =
              preNatal.resultado
          }

          if (hivSifilis != undefined) {
            this.indicadores.pn_hiv_sifilis_denominador_preliminar =
              hivSifilis.denominador
            this.indicadores.pn_hiv_sifilis_numerador_preliminar =
              hivSifilis.numerador
            this.indicadores.pn_hiv_sifilis_resultado_preliminar =
              hivSifilis.resultado
          }

          if (odontologia != undefined) {
            this.indicadores.pn_odontologia_denominador_preliminar =
              odontologia.denominador
            this.indicadores.pn_odontologia_numerador_preliminar =
              odontologia.numerador
            this.indicadores.pn_odontologia_resultado_preliminar =
              odontologia.resultado
          }

          if (citologico != undefined) {
            this.indicadores.citopatologico_denominador_preliminar =
              citologico.denominador
            this.indicadores.citopatologico_numerador_preliminar =
              citologico.numerador
            this.indicadores.citopatologico_resultado_preliminar =
              citologico.resultado
          }

          if (polioPenta != undefined) {
            this.indicadores.crianca_polio_penta_denominador_preliminar =
              polioPenta.denominador
            this.indicadores.crianca_polio_penta_numerador_preliminar =
              polioPenta.numerador
            this.indicadores.crianca_polio_penta_resultado_preliminar =
              polioPenta.resultado
          }

          if (hipertensao != undefined) {
            this.indicadores.pa_hipertensao_denominador_preliminar =
              hipertensao.denominador
            this.indicadores.pa_hipertensao_numerador_preliminar =
              hipertensao.numerador
            this.indicadores.pa_hipertensao_resultado_preliminar =
              hipertensao.resultado
          }

          if (diabetes != undefined) {
            this.indicadores.hg_diabetes_denominador_preliminar =
              diabetes.denominador
            this.indicadores.hg_diabetes_numerador_preliminar =
              diabetes.numerador
            this.indicadores.hg_diabetes_resultado_preliminar =
              diabetes.resultado
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    corResultadoIndicador(resultado, indicador) {
      switch (indicador) {
        case 'pre-natal':
          if (parseInt(resultado) >= 60) {
            return 'blue'
          } else {
            return 'red'
          }
          break
        case 'hiv-sifilis':
          if (parseInt(resultado) >= 60) {
            return 'blue'
          } else {
            return 'red'
          }
          break
        case 'consultas-odontologicas':
          if (parseInt(resultado) >= 60) {
            return 'blue'
          } else {
            return 'red'
          }
          break
        case 'citopatologico':
          if (parseInt(resultado) >= 40) {
            return 'blue'
          } else {
            return 'red'
          }
          break
        case 'polio-penta':
          if (parseInt(resultado) >= 95) {
            return 'blue'
          } else {
            return 'red'
          }
          break
        case 'hipertensao':
          if (parseInt(resultado) >= 50) {
            return 'blue'
          } else {
            return 'red'
          }
          break
        case 'hemoglobina':
          if (parseInt(resultado) >= 50) {
            return 'blue'
          } else {
            return 'red'
          }
          break
        default:
          break
      }
    },

    printData(
      numerador,
      denominador,
      denominador_estimado,
      resultado,
      indicador,
      quadrimestre
    ) {
      if (
        (numerador !== '' &&
          denominador !== '' &&
          denominador_estimado !== '' &&
          resultado !== '',
        quadrimestre)
      ) {
        let template = `<td>
                                ${numerador}
                            </td>
                        <td>
                            ${denominador}
                        </td>
                    `
        let resultado_template = ''

        switch (indicador) {
          case 'pre-natal':
            if (parseInt(resultado) >= 60) {
              resultado_template = `<b class="blue">${resultado}%</b>`
            } else {
              resultado_template = `<b class="red">${resultado}%</b>`
            }
            break
          case 'hiv-sifilis':
            if (parseInt(resultado) >= 60) {
              resultado_template = `<b class="blue">${resultado}%</b>`
            } else {
              resultado_template = `<b class="red">${resultado}%</b>`
            }
            break
          case 'consultas-odontologicas':
            if (parseInt(resultado) >= 60) {
              resultado_template = `<b class="blue">${resultado}%</b>`
            } else {
              resultado_template = `<b class="red">${resultado}%</b>`
            }
            break
          case 'citopatologico':
            if (parseInt(resultado) >= 40) {
              resultado_template = `<b class="blue">${resultado}%</b>`
            } else {
              resultado_template = `<b class="red">${resultado}%</b>`
            }
            break
          case 'polio-penta':
            if (parseInt(resultado) >= 95) {
              resultado_template = `<b class="blue">${resultado}%</b>`
            } else {
              resultado_template = `<b class="red">${resultado}%</b>`
            }
            break
          case 'hipertensao':
            if (parseInt(resultado) >= 50) {
              resultado_template = `<b class="blue">${resultado}%</b>`
            } else {
              resultado_template = `<b class="red">${resultado}%</b>`
            }
            break
          case 'hemoglobina':
            if (parseInt(resultado) >= 50) {
              resultado_template = `<b class="blue">${resultado}%</b>`
            } else {
              resultado_template = `<b class="red">${resultado}%</b>`
            }
            break
          default:
            break
        }

        template += `<td>
                                ${resultado_template}
                            </td>`

        template += `<td>
                            ${quadrimestre}
                        </td>`

        template += `<td>
                            Definitivo
                        </td>`
        template += `<td>
                            SISAB
                        </td>`

        return template
      }
    },

    printDataPrevisao(numerador, denominador, resultado, indicador) {
      if (numerador !== '' && denominador !== '') {
        let template = `<td>
                                ${numerador}
                            </td>
                        <td>
                            ${denominador}
                        </td>
                    `
        let resultado_template = ''

        switch (indicador) {
          case 'pre-natal':
            if (parseInt(resultado) >= 45) {
              resultado_template = `<b class="blue">${resultado}%</b>`
            } else {
              resultado_template = `<b class="red">${resultado}%</b>`
            }
            break
          case 'hiv-sifilis':
            if (parseInt(resultado) >= 60) {
              resultado_template = `<b class="blue">${resultado}%</b>`
            } else {
              resultado_template = `<b class="red">${resultado}%</b>`
            }
            break
          case 'consultas-odontologicas':
            if (parseInt(resultado) >= 60) {
              resultado_template = `<b class="blue">${resultado}%</b>`
            } else {
              resultado_template = `<b class="red">${resultado}%</b>`
            }
            break
          case 'citopatologico':
            if (parseInt(resultado) >= 40) {
              resultado_template = `<b class="blue">${resultado}%</b>`
            } else {
              resultado_template = `<b class="red">${resultado}%</b>`
            }
            break
          case 'polio-penta':
            if (parseInt(resultado) >= 95) {
              resultado_template = `<b class="blue">${resultado}%</b>`
            } else {
              resultado_template = `<b class="red">${resultado}%</b>`
            }
            break
          case 'hipertensao':
            if (parseInt(resultado) >= 50) {
              resultado_template = `<b class="blue">${resultado}%</b>`
            } else {
              resultado_template = `<b class="red">${resultado}%</b>`
            }
            break
          case 'hemoglobina':
            if (parseInt(resultado) >= 50) {
              resultado_template = `<b class="blue">${resultado}%</b>`
            } else {
              resultado_template = `<b class="red">${resultado}%</b>`
            }
            break
          default:
            break
        }

        template += `<td>
                               ${resultado_template}
                            </td>`

        template += `<td>
                            ${this.verificaQuadrimestre()}
                        </td>`

        template += `<td>
                            Previsão
                        </td>`

        template += `<td>
                            e-SUS PEC
                        </td>`

        return template
      }
    },

    verificaQuadrimestre() {
      let quadrimestre_atual = ''
      let data_atual = new Date()
      let mes_atual = parseInt(data_atual.getMonth() + 1) // janeiro=0
      let ano_atual = parseInt(data_atual.getFullYear())
      if (mes_atual >= 1 && mes_atual <= 4) {
        quadrimestre_atual = ano_atual + ' Q1'
      } else if (mes_atual >= 5 && mes_atual <= 8) {
        quadrimestre_atual = ano_atual + ' Q2'
      } else if (mes_atual >= 9 && mes_atual <= 12) {
        quadrimestre_atual = ano_atual + ' Q3'
      } else {
        quadrimestre_atual = ''
      }
      return quadrimestre_atual
    },

    resetIndicadores() {
      this.indicadores.citopatologico_numerador = ''
      this.indicadores.citopatologico_denominador = ''
      this.indicadores.citopatologico_denominador_estimado = ''
      this.indicadores.citopatologico_resultado = ''
      this.indicadores.pn_6_consultas_numerador = ''
      this.indicadores.pn_6_consultas_denominador = ''
      this.indicadores.pn_6_consultas_denominador_estimado = ''
      this.indicadores.pn_6_consultas_resultado = ''
      this.indicadores.pn_odontologia_numerador = ''
      this.indicadores.pn_odontologia_denominador = ''
      this.indicadores.pn_odontologia_denominador_estimado = ''
      this.indicadores.pn_odontologia_resultado = ''
      this.indicadores.pn_hiv_sifilis_numerador = ''
      this.indicadores.pn_hiv_sifilis_denominador = ''
      this.indicadores.pn_hiv_sifilis_denominador_estimado = ''
      this.indicadores.pn_hiv_sifilis_resultado = ''
      this.indicadores.hg_diabetes_numerador = ''
      this.indicadores.hg_diabetes_denominador = ''
      this.indicadores.hg_diabetes_denominador_estimado = ''
      this.indicadores.hg_diabetes_resultado = ''
      this.indicadores.pa_hipertensao_numerador = ''
      this.indicadores.pa_hipertensao_denominador = ''
      this.indicadores.pa_hipertensao_denominador_estimado = ''
      this.indicadores.pa_hipertensao_resultado = ''
      this.indicadores.crianca_polio_penta_numerador = ''
      this.indicadores.crianca_polio_penta_denominador = ''
      this.indicadores.crianca_polio_penta_denominador_estimado = ''
      this.indicadores.crianca_polio_penta_resultado = ''
      this.indicadores.quadrimestre = ''
    },

    init() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
    },
  },
}
</script>

<style>
#accordion-indicadores header {
  background-color: #fff;
  background-image: none;
  padding: 10px;
}
#accordion-indicadores header button {
  background-color: transparent;
  border: none;
  color: #000;
  width: 100%;
  text-align: left;
  border-radius: 0;
  height: auto;
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
#accordion-indicadores .card {
  padding: 0;
}
#accordion-indicadores .card .card-body {
  padding: 0;
}
#accordion-indicadores .card .card-body table {
  margin-bottom: 0;
  text-align: center;
}
#accordion-indicadores .when-opened,
#accordion-indicadores .when-closed {
  float: right;
  font-size: 25px;
}
#accordion-indicadores .collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}

#accordion-indicadores .line-through {
  position: relative;
}

#accordion-indicadores .line-through::after {
  border-bottom: 0.125em solid #000;
  content: '';
  left: 0;
  margin-top: calc(0.125em / 2 * -1);
  position: absolute;
  right: 0;
  top: 50%;
  width: 25px;
  margin: 0 auto;
}

#accordion-indicadores table tbody tr td {
  font-size: 16px !important;
}

#accordion-indicadores table tbody tr td .blue {
  color: #3c8dbc;
}

#accordion-indicadores table tbody tr td .red {
  color: red;
}
</style>
